<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Guideline Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout row wrap pl-3 pr-3>
              <v-flex xs12>
                <!-- <v-text-field label="Guideline Long Name" v-model="guidelineData.GuidelineLongName" :rules="guidelineLongNameRules" :readonly="!isTenantEditable"></v-text-field>
                <v-text-field label="Guideline short Name" v-model="guidelineData.GuidelineName" :rules="guidelineShortNameRules" :readonly="!isTenantEditable"></v-text-field>
                <v-combobox ref="category" label="Category" v-model="guidelineData.Category" :items="guidelinesCategory" :rules="categoryRules" :readonly="!isTenantEditable"></v-combobox>
                <v-select label="Media Types" v-model="guidelineData.Medias" :items="mediaTypeList" multiple item-text="Name"
                  :rules="mediaTypeRules" return-object :readonly="!isTenantEditable"></v-select> -->
                <v-list style="padding: 0px" two-line>
                  <v-list-tile>
                    <v-list-tile-content style="width: 30%;">
                      <v-list-tile-title><b>Guideline Long Name</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <div class="subheading"><b>{{ guidelineData.GuidelineLongName }}</b></div>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content style="width: 30%;">
                      <v-list-tile-title><b>Guideline short Name</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <div class="subheading"><b>{{ guidelineData.GuidelineName }}</b></div>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content style="width: 30%;">
                      <v-list-tile-title><b>Category</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <div class="subheading"><b>{{ guidelineData.Category }}</b></div>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content style="width: 30%;">
                      <v-list-tile-title><b>Media Types</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <div class="subheading"><b>{{ MediasToString(guidelineData.Medias) }}</b></div>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <!-- <v-btn class="centerBtn" color="success" @click="clickSave()" :disabled="!isTenantEditable">{{ $t('Button.Save') }}</v-btn> -->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>

    <v-card>
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { AddGuidelineActionName } from '@/components/mixins/GuidelinesManageUtil'
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  export default {
    props: {
      actionName: {
        type: String,
        default: '',
      },
      currentGuideline: {
        type: Object,
        default: () => {},
      },
      isAddpageForm: {
        type: Boolean,
        default: true,
      },
      isTenantEditable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        valid: true,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        guidelineData: {},
        originalData: {},

        categoryRules: [
          (v) => !!v || 'Category is required',
        ],
        mediaTypeRules: [
          (v) => (!!v && !!v.length) || 'Media Type is required',
        ],
      }
    },
    mounted() {
      this.setGuidelineData()
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['isTenantAdmin', 'currentUserGroup']),
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines', 'guidelinesCategory']),

      guidelineLongNameRules() {
        if (this.actionName == AddGuidelineActionName) {
          return [
            (v) => !!v || 'Guideline Long Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineLongName == v) || 'This Guideline Long Name already exists',
          ]
        } else {
          return [
            (v) => !!v || 'Guideline Long Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineLongName == v && x.GuidelineLongName != this.currentGuideline
              .GuidelineLongName) || 'This Guideline Long Name already exists',
          ]
        }
      },
      guidelineShortNameRules() {
        if (this.actionName == AddGuidelineActionName) {
          return [
            (v) => !!v || 'Guideline Short Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineName == v) || 'This Guideline Short Name already exists',
          ]
        } else {
          return [
            (v) => !!v || 'Guideline Short Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineName == v && x.GuidelineName != this.currentGuideline.GuidelineName) ||
            'This Guideline Short Name already exists',
          ]
        }
      },
    },
    watch: {
      currentGuideline() {
        this.setGuidelineData()
      },
      snackbar() {
        if (this.isAddpageForm && !this.snackbar) {
          this.$router.push({
            name: 'guidelinesDetail',
            params: {
              name: this.guidelineData.GuidelineName,
            },
          })
        }
      },
    },
    methods: {
      ...guidelines.mapActions(['postAddNewGuideline', 'postUpdateGuideline', 'postAddGuidelineTenant']),
      startSnack(snackColor, snackMessage) {
        this.snackMessage = snackMessage
        this.snackColor = snackColor
        this.snackbar = true
      },
      MediasToString(data) {
        if (data) {
          return data.toString()
        }
        return
      },
      setGuidelineData() {
        if (this.actionName != AddGuidelineActionName && !this.isAddpageForm) {
          this.guidelineData = JSON.parse(JSON.stringify(this.currentGuideline))
          let arr = []
          this.guidelineData.Medias.forEach(e => {
            //let media = this.mediaTypeList.find(x => x.Name == e.Name)
            arr.push(e.Name)
          })
          this.guidelineData.Medias = arr
          this.originalData = this.guidelineData
        }
      },
      clickSave() {
        if (this.$refs.form.validate()) {
          this.guidelineData.Category = this.$refs.category.internalSearch.trim()
          let options = {
            data: {
              Id: this.guidelineData.Id ? this.guidelineData.Id : null,
              Name: this.guidelineData.GuidelineName,
              LongName: this.guidelineData.GuidelineLongName,
              Category: this.guidelineData.Category,
              MediaTypes: this.guidelineData.Medias,
              Standards: this.guidelineData.Standards,
              TenantGuidelines: this.guidelineData.TenantGuidelines,
            },
            addSuccessCb: (data) => {
              this.addGuidelineTenant(data.Id)
            },
            updateSuccessCb: () => {
              this.startSnack('success', this.$t('GuidelinesDetailForm.updateSuccessMsg', { msg: this.guidelineData.GuidelineName }))
            },
            failedCb: (err) => {
              this.startSnack('error', err)
            },
          }
          if (this.isAddpageForm) {
            this.postAddNewGuideline(options)
          } else {
            this.postUpdateGuideline(options)
          }
        }
      },
      addGuidelineTenant(guidelineId) {
        let options = {
          data: {
            GuidelineId: guidelineId,
            Tenants: [{
              IsEditable: true,
              TenantId: this.currentUserGroup.id,
            }],
          },
          successCb: () => {
            this.startSnack('success', this.$t('GuidelinesDetailForm.addSuccessMsg', { msg: this.guidelineData.GuidelineName }))
          },
          failedCb: (err) => {
            this.startSnack('error', err)
          },
        }
        this.postAddGuidelineTenant(options)
      },
    },
  }
</script>

<style scoped>
  .backgroundColor {
    background-color: #fafafa
  }

  .removePadding {
    padding: 0px;
  }

  .centerBtn {
    margin: 0 auto;
    display: block;
    width: 40%;
  }
</style>